import { render, staticRenderFns } from "./ECommerceCollectionAndHandle.vue?vue&type=template&id=1448df6a&scoped=true&"
import script from "./ECommerceCollectionAndHandle.vue?vue&type=script&lang=js&"
export * from "./ECommerceCollectionAndHandle.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceCollectionAndHandle.vue?vue&type=style&index=0&id=1448df6a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1448df6a",
  null
  
)

export default component.exports